/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddressViewModel } from './AddressViewModel';
import {
    AddressViewModelFromJSON,
    AddressViewModelFromJSONTyped,
    AddressViewModelToJSON,
} from './AddressViewModel';
import type { ContactPersonViewModel } from './ContactPersonViewModel';
import {
    ContactPersonViewModelFromJSON,
    ContactPersonViewModelFromJSONTyped,
    ContactPersonViewModelToJSON,
} from './ContactPersonViewModel';
import type { NonTaxableInstitutionPartyDetailsViewModel } from './NonTaxableInstitutionPartyDetailsViewModel';
import {
    NonTaxableInstitutionPartyDetailsViewModelFromJSON,
    NonTaxableInstitutionPartyDetailsViewModelFromJSONTyped,
    NonTaxableInstitutionPartyDetailsViewModelToJSON,
} from './NonTaxableInstitutionPartyDetailsViewModel';
import type { ThirdPartyOrganisationFinancialAndTax } from './ThirdPartyOrganisationFinancialAndTax';
import {
    ThirdPartyOrganisationFinancialAndTaxFromJSON,
    ThirdPartyOrganisationFinancialAndTaxFromJSONTyped,
    ThirdPartyOrganisationFinancialAndTaxToJSON,
} from './ThirdPartyOrganisationFinancialAndTax';

/**
 * 
 * @export
 * @interface NonTaxableInstitutionThirdPartyViewModel
 */
export interface NonTaxableInstitutionThirdPartyViewModel {
    /**
     * 
     * @type {number}
     * @memberof NonTaxableInstitutionThirdPartyViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {NonTaxableInstitutionPartyDetailsViewModel}
     * @memberof NonTaxableInstitutionThirdPartyViewModel
     */
    nonTaxableInstitutionDetails?: NonTaxableInstitutionPartyDetailsViewModel;
    /**
     * 
     * @type {ThirdPartyOrganisationFinancialAndTax}
     * @memberof NonTaxableInstitutionThirdPartyViewModel
     */
    financialAndTax?: ThirdPartyOrganisationFinancialAndTax;
    /**
     * 
     * @type {ContactPersonViewModel}
     * @memberof NonTaxableInstitutionThirdPartyViewModel
     */
    contactPerson?: ContactPersonViewModel;
    /**
     * 
     * @type {AddressViewModel}
     * @memberof NonTaxableInstitutionThirdPartyViewModel
     */
    registeredAddress?: AddressViewModel;
}

/**
 * Check if a given object implements the NonTaxableInstitutionThirdPartyViewModel interface.
 */
export function instanceOfNonTaxableInstitutionThirdPartyViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NonTaxableInstitutionThirdPartyViewModelFromJSON(json: any): NonTaxableInstitutionThirdPartyViewModel {
    return NonTaxableInstitutionThirdPartyViewModelFromJSONTyped(json, false);
}

export function NonTaxableInstitutionThirdPartyViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonTaxableInstitutionThirdPartyViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'nonTaxableInstitutionDetails': !exists(json, 'NonTaxableInstitutionDetails') ? undefined : NonTaxableInstitutionPartyDetailsViewModelFromJSON(json['NonTaxableInstitutionDetails']),
        'financialAndTax': !exists(json, 'FinancialAndTax') ? undefined : ThirdPartyOrganisationFinancialAndTaxFromJSON(json['FinancialAndTax']),
        'contactPerson': !exists(json, 'ContactPerson') ? undefined : ContactPersonViewModelFromJSON(json['ContactPerson']),
        'registeredAddress': !exists(json, 'RegisteredAddress') ? undefined : AddressViewModelFromJSON(json['RegisteredAddress']),
    };
}

export function NonTaxableInstitutionThirdPartyViewModelToJSON(value?: NonTaxableInstitutionThirdPartyViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'NonTaxableInstitutionDetails': NonTaxableInstitutionPartyDetailsViewModelToJSON(value.nonTaxableInstitutionDetails),
        'FinancialAndTax': ThirdPartyOrganisationFinancialAndTaxToJSON(value.financialAndTax),
        'ContactPerson': ContactPersonViewModelToJSON(value.contactPerson),
        'RegisteredAddress': AddressViewModelToJSON(value.registeredAddress),
    };
}

